import axios from 'axios';
import type {
  FindTransferLogsByUserIdResponse,
  JsonObject,
} from '@/app-package';

export type FindTransferLogsByUserId =
  JsonObject<FindTransferLogsByUserIdResponse>;

interface FindLogParams {
  userId: string;
}

const findLog = async ({ userId }: FindLogParams) => {
  const { data } = await axios.get<FindTransferLogsByUserId>(
    `/history/transfers_by_user/${userId}`,
  );
  return data;
};

export default findLog;
